export class IngestionPipelineAggregationMetrics {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "outputId",
            "baseName": "outputId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "tableNamespace",
            "baseName": "tableNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "publishedEpoch",
            "baseName": "publishedEpoch",
            "type": "number",
            "format": ""
        },
        {
            "name": "secondsSinceLastPublish",
            "baseName": "secondsSinceLastPublish",
            "type": "number",
            "format": ""
        },
        {
            "name": "secondsSinceLastSeal",
            "baseName": "secondsSinceLastSeal",
            "type": "number",
            "format": ""
        },
        {
            "name": "secondsSinceLastAdmission",
            "baseName": "secondsSinceLastAdmission",
            "type": "number",
            "format": ""
        },
        {
            "name": "rowsUpsertedPerSec",
            "baseName": "rowsUpsertedPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "rowsUpserted24h",
            "baseName": "rowsUpserted24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "acceptedRowsPerSec",
            "baseName": "acceptedRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "expiredRowsPerSec",
            "baseName": "expiredRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "filteredRowsPerSec",
            "baseName": "filteredRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "duplicateRowsPerSec",
            "baseName": "duplicateRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "deletedRowsPerSec",
            "baseName": "deletedRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "stateFiles",
            "baseName": "stateFiles",
            "type": "number",
            "format": ""
        },
        {
            "name": "liveKeys",
            "baseName": "liveKeys",
            "type": "number",
            "format": ""
        },
        {
            "name": "entryJudgedKeys24h",
            "baseName": "entryJudgedKeys24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "entryJoinedKeys24h",
            "baseName": "entryJoinedKeys24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "entryLeftKeys24h",
            "baseName": "entryLeftKeys24h",
            "type": "number",
            "format": ""
        },
        {
            "name": "reduceRowsPerSec",
            "baseName": "reduceRowsPerSec",
            "type": "number",
            "format": ""
        },
        {
            "name": "tableSizeBytes",
            "baseName": "tableSizeBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "aggregatorPods",
            "baseName": "aggregatorPods",
            "type": "number",
            "format": ""
        },
        {
            "name": "committerPods",
            "baseName": "committerPods",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactorPods",
            "baseName": "compactorPods",
            "type": "number",
            "format": ""
        },
        {
            "name": "cleanerPods",
            "baseName": "cleanerPods",
            "type": "number",
            "format": ""
        },
        {
            "name": "restarts1h",
            "baseName": "restarts1h",
            "type": "number",
            "format": ""
        },
        {
            "name": "computeUsdPerHour",
            "baseName": "computeUsdPerHour",
            "type": "number",
            "format": ""
        },
        {
            "name": "servingFreshnessSeconds",
            "baseName": "servingFreshnessSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "servingDiskBytes",
            "baseName": "servingDiskBytes",
            "type": "number",
            "format": ""
        },
        {
            "name": "servingPods",
            "baseName": "servingPods",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineAggregationMetrics.attributeTypeMap;
    }
    constructor() {
    }
}
